import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { NegotiationCaseCreateWizardState } from '../NegotiationCaseCreateWizard/NegotiationCaseCreateWizard.schema';
import { I18nNamespace } from '~/common/types';
import { DialogActionsLayout } from '~/components/DialogWizard/components/DialogActionsLayout/DialogActionsLayout';
import { useWizardFormControls } from '~/components/WizardState/hooks/useWizardFormControls/useWizardFormControls';

export const SelectQuoteActions = () => {
  const { disabled, cancel } = useWizardFormControls<NegotiationCaseCreateWizardState>();
  const { t: tGeneralActions } = useTranslation(I18nNamespace.common, { keyPrefix: 'DialogWizard.general.actions' });

  return (
    <DialogActionsLayout
      left={
        <Button disabled={disabled} onClick={cancel}>
          {tGeneralActions('cancel')}
        </Button>
      }
    ></DialogActionsLayout>
  );
};
